export const SEARCH_DRAWER_TAB_PARAM_KEY = 'search-drawer-tab';
